export interface AlertModel {
    type: AlertType;
    icon: IconAlert;
    message: string;
    closable: boolean;
    visible?: boolean;
    params?: unknown;
    show?: (obj: unknown) => boolean;
}

export class Alert implements AlertModel {
    type: AlertType;
    icon: IconAlert;
    message: string;
    closable: boolean;
    params?: unknown;
    visible? = false;
    show: (obj: unknown) => boolean = () => false;

    constructor(alert: AlertModel) {
        Object.assign(this, alert);
    }

    setVisibility(obj: unknown): void {
        this.params = obj;
        this.visible = this.show(obj);
    }

    close(): void {
        this.visible = false;
    }
}

export enum AlertType {
    SUCCESS = "success",
    INFO = "info",
    WARNING = "warning",
    ERROR = "error",
}

export interface IconAlert {
    key: string;
    color: string;
    isSvg: boolean;
}
